module.exports = __webpack_public_path__ + "static/media/main_logo.9c3f5371.png";